const cacheStore = new Map();

const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function buildCacheKey(prefix, params) {
  if (params === undefined || params === null) {
    return `${prefix}:`;
  }
  if (typeof params !== 'object') {
    return `${prefix}:${String(params)}`;
  }
  const sortedKeys = Object.keys(params).sort();
  const normalized = {};
  for (const k of sortedKeys) {
    if (params[k] !== undefined) {
      normalized[k] = params[k];
    }
  }
  return `${prefix}:${JSON.stringify(normalized)}`;
}

export function cachedGet(key, fetcher, ttlMs = DEFAULT_TTL_MS) {
  const now = Date.now();
  const existing = cacheStore.get(key);

  if (existing) {
    if (existing.promise) {
      return existing.promise;
    }
    if (existing.expiresAt > now) {
      return Promise.resolve(existing.value);
    }
    cacheStore.delete(key);
  }

  // Giữ tham chiếu tới entry đang chờ: nếu cache bị invalidate (hoặc thay bằng
  // request mới) trong lúc fetch thì kết quả cũ không được ghi đè lên.
  const entry = {
    value: undefined,
    expiresAt: 0,
    promise: null,
  };

  entry.promise = Promise.resolve()
    .then(() => fetcher())
    .then((result) => {
      if (cacheStore.get(key) === entry) {
        cacheStore.set(key, {
          value: result,
          expiresAt: Date.now() + ttlMs,
          promise: null,
        });
      }
      return result;
    })
    .catch((err) => {
      if (cacheStore.get(key) === entry) {
        cacheStore.delete(key);
      }
      throw err;
    });

  cacheStore.set(key, entry);

  return entry.promise;
}

export function invalidateCache(prefix) {
  if (!prefix) {
    cacheStore.clear();
    return;
  }
  for (const key of Array.from(cacheStore.keys())) {
    if (key === prefix || key.startsWith(prefix)) {
      cacheStore.delete(key);
    }
  }
}

export function clearAllCache() {
  cacheStore.clear();
}
